<!-- 
  使用：
    <File-Loading></File-Loading>
  属性：
    title=""   // string
 -->
<template>
  <div class="custom-cover">
    <div class="my-file-loading">
      <i
        class="my-file-loading-close"
        @click="$store.state.customFileLoading = false"
      ></i>
      <p class="my-file-loading-title">{{ title }}</p>
      <div class="my-file-loading-track">
        <div class="my-file-loading-bar"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FileLoading",
  props: ["title"],
  data() {
    return {
      loopObj: null
    };
  },
  methods: {
    loop() {
      let repeat = document.querySelector(".my-file-loading-bar");
      let flag = 0;
      this.loopObj = setInterval(() => {
        flag++;
        if (flag === 460) {
          flag = 0;
        }
        repeat.style.left = -flag + "px";
      }, 1000 / 80);
    }
  },
  mounted() {
    this.loop();
  },
  destroyed() {
    clearInterval(this.loopObj);
    this.loopObj = null;
  }
};
</script>

<style lang="less" scoped>
.custom-cover {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.6);
  z-index: 10086;
  .my-file-loading {
    width: 600px;
    height: 126px;
    background: #ffffff;
    border: 1px solid #edf0fc;
    box-shadow: 0px 4px 10px rgba(48, 49, 51, 0.1);
    opacity: 1;
    border-radius: 4px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    padding: 20px;
    .my-file-loading-close {
      width: 20px;
      height: 20px;
      background: url(../../assets/image/closeIcon.png);
      background-size: cover;
      position: absolute;
      top: 20px;
      right: 20px;
      cursor: pointer;
    }
    .my-file-loading-title {
      margin: 12px 0 20px;
      font-size: 16px;
      font-weight: bold;
      line-height: 22px;
      color: #303133;
    }
    .my-file-loading-track {
      width: 480px;
      height: 12px;
      overflow: hidden;
      border-radius: 4px;
    }
    .my-file-loading-bar {
      position: relative;
      width: 960px;
      height: 12px;
      display: flex;
      align-items: center;
      background: url(../../assets/image/组3858.png);
      background-size: cover;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CustomComponent/FileLoading.vue